export const siteRoutes = {
  home: "/",
  download: "/download",
  login: "/login",
  about: "/about",
  keys: "/keys",
  privacy: "/privacy",
  terms: "/terms",
  support: "/support",
} as const;

export const siteRoutePaths = Object.values(siteRoutes);

export function childRoutePath(path: string) {
  return path.replace(/^\//, "");
}
